import React from "react";
import { Typography, TypographyProps, SxProps, Theme } from "@mui/material";
import { applyGradientText } from "../../constants/gradient";

type TextGradientProps = TypographyProps & {
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
};

/**
 * Reusable Typography component with gradient text styling
 * Automatically applies the standard gradient based on theme mode
 */
const TextGradient: React.FC<TextGradientProps> = ({ children, sx, ...props }) => {
  return (
    <Typography
      {...props}
      sx={[
        (theme) => applyGradientText(theme),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Typography>
  );
};

export default TextGradient;

